<template>
	<div>

		<div class="btns-top">
			<button class="btn btn-submit fa fa-save transition-fadeinup transition-delay-01" @click="submitSettingsClickHandler"></button>
		</div>

		<div class="row">
			<div class="col-20 transition-fadeinup">
				<h2>Defaults</h2>

				<table cellpadding="0" cellspacing="0" class="data">
					<tbody v-if="settings">

						<tr>
							<td>Website url</td>
							<td v-if="settings">
								<input type="text" name="url" placeholder="https://three-sixty.be" v-model="settings.domains[Object.keys(settings.domains)[0]].domain">
							</td>
						</tr>
						<tr>
							<td>Website name</td>
							<td>
								<input type="text" name="name" placeholder="Three-Sixty" v-model="settings.name">
							</td>
						</tr>
						<tr>
							<td>Hosting maintenance contract</td>
							<td>
								<input type="text" name="maintenance" placeholder="Inactive" v-model="settings.maintenance_contract">
							</td>
						</tr>
						<tr>
							<td>Hosting expiration date domain</td>
							<td>
								<input type="text" name="domain_expiration" placeholder="December" v-model="settings.maintenance_contract_expires">
							</td>
						</tr>
						<tr>
							<td>Hosting expiration date hosting</td>
							<td>
								<input type="text" name="hosting_expiration" placeholder="December">
							</td>
						</tr>
						<tr>
							<td>Freshdesk ID</td>
							<td>
								<input type="text" name="freshdesk_id" placeholder="xxxxxxxxxxx" v-model="settings.freshdesk_id">
							</td>
						</tr>
					</tbody>

				</table>
			</div>
		</div>

		<br>

		<div class="row">
			<div class="col-12 transition-fadeinup">
				<h2>Image Purge</h2>
				<p>Delete all orphaned images (images that aren't used in any objects) and deletes all generated images/thumbnails</p>

				<template v-if="imagesPurged">
					<p>{{imagesPurged}}</p>
				</template>

				<button class="btn" @click="imagePurgeClickHandler">Purge</button>
			</div>
		</div>

		<br>
		<br>

		<div class="row">
			<div class="col-12 transition-fadeinup">
				<h2>Create optimized images</h2>
				<button class="btn" @click="createImagesClickHandler" :disabled="optimizeBtnDisabled">Create</button>
			</div>
		</div>

		<br>
		<br>

		<div class="row">
			<div class="col-12 transition-fadeinup">
				<h2>Delete unused editabled references</h2>
				<p>Delete all orphaned instances that are not referenced anymore</p>

				<template v-if="orphansDeleted">
					<p>{{orphansDeleted}}</p>
				</template>

				<template v-else>

					<p v-if="!orphans && searching"><i>Searching for orphans</i></p>

					<ul class="list" v-for="orphan in orphans" :key="orphan.id">
						<li>{{orphan.entt_name}}: {{orphan.orphans}}</li>
					</ul>

				</template>

				<br>

				<button class="btn" @click="searchOrphans">Search for orphans</button>
				<button class="btn" @click="editableReferencesPurge">Delete</button>
			</div>
		</div>

	</div>

</template>

<script>

import xhrModule from '../../modules/xhrModule.js'

export default {
	name: 'site-settings',
	data () {
		return {
			searching: false,
			orphans: null,
			orphansDeleted: null,
			imagesPurged: null,
			optimizeBtnDisabled: null,
			settings: null
		}
	},

	created () {
		this.body = document.querySelector('body')

		// fetch project data
		var url = '/cms/api/projects'
		xhrModule.get(url, this.fetchProjectsCompleteHandler.bind(this))
	},

	methods: {
		fetchProjectsCompleteHandler (data) {
			this.settings = data[Object.keys(data)[0]]
		},

		imagePurgeClickHandler (e) {
			e.preventDefault()
			var url = '/cms/api/cache/purgeUploads'
			xhrModule.get(url, this.purgeImagesCompleteHandler.bind(this))
		},

		createImagesClickHandler (e) {
			this.createOptimizedImages()
		},

		createOptimizedImages () {
			this.body.classList.add('loading')
			var url = '/cms/api/upload/batch'
			xhrModule.get(url, this.optimizeImagesCompleteHandler.bind(this), this.optimizeImagesFailed.bind(this))
		},

		optimizeImagesCompleteHandler (data, statusCode) {
			this.body.classList.remove('loading')

			// disable button
			this.optimizeBtnDisabled = 'disabled'
		},

		optimizeImagesFailed (data) {
			this.body.classList.remove('loading')
			// keep fetching when we are getting timeouts from the server
			if (data === 'timeout') this.createOptimizedImages()
		},

		editableReferencesPurge (e) {
			e.preventDefault()
			var json = JSON.stringify({})
			var url = '/cms/api/maintenance/orphans'
			xhrModule.post(url, json, this.deleteOrphansCompleteHandler.bind(this))
		},

		searchOrphans () {
			this.searching = true
			// GET the list of orphans that is about to be deleted
			var url = '/cms/api/maintenance/orphans'
			xhrModule.get(url, this.getOrphansCompleteHandler.bind(this))
		},

		getOrphansCompleteHandler (orphans) {
			this.orphans = orphans.data
		},

		deleteOrphansCompleteHandler (orphans) {
			this.orphansDeleted = orphans.data
		},

		purgeImagesCompleteHandler (r) {
			this.imagesPurged = r.data
		},

		submitSettingsClickHandler (e) {
			e.preventDefault()

			// post project data
			var url = '/cms/api/projects'
			var json = JSON.stringify(this.settings)
			xhrModule.post(url, json, this.postProjectsCompleteHandler.bind(this))
		},

		postProjectsCompleteHandler (data) {
			console.log('done')
		}
	}
}

</script>
